import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule} from 'devextreme-angular';
import {CtlGenKullaniciAramaComponent} from './ctl-gen-kullanici-arama/ctl-gen-kullanici-arama.component';
import {GenKullaniciService} from './ctl-gen-kullanici.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {DkGlobalUserSettingsService} from '../../../services/dk-global-user-settings.service';

@Component({
  selector: 'dk-ctl-gen-kullanici',
  templateUrl: './ctl-gen-kullanici.component.html',
  styleUrls: ['./ctl-gen-kullanici.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGenKullaniciAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
  ],
  providers: [GenKullaniciService],
})
export class CtlGenKullaniciComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = this.globalSettings.globalLabelMode;
  @Input() code: any;
  @Input() codeField="Kod";
  @Input() isPersonel = false;
  @Input() isActive = false;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();
  public crudPopupVisible = false;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "GenKullanici";

  public data: any;


  constructor(private service: GenKullaniciService, private utilsService: UtilsService, private ortakService: OrtakService,
              private globalSettings: DkGlobalUserSettingsService
  ) {
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    this.service.setParams(this.isPersonel, this.isActive, this.codeField,this.isReadOnly,this.isBindCheck)
  }
    ngOnChanges(changes: SimpleChanges) {
      if (changes['isReadOnly'] || changes['isBindCheck']) {
          this.service.setParams(this.isPersonel, this.isActive, this.codeField,this.isReadOnly,this.isBindCheck)
        }
    }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;
        }
      });
  }

  searchClick() {
    this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (e === '' || e === null) this.clear();
    else if (!this.isFirst) this.getData(e);
    this.isFirst = false;
  }

  getData(code: any, isSetData?: boolean) {
    this.data = this.service.getData(code,this.control, this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = this.constructTitle(result[0]); // Use the new method
        this.code = result[0][this.codeField];
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst = true;
      this.data = result.data;
      this.title = this.constructTitle(result.data); // Use the new method
      this.code = result.data[this.codeField];
      this.dataResult.emit(this.data);
    } else {
      this.dataResult.emit(null);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }

  private constructTitle(data: any): string {
    let title = '';
    if (data.Adi) title += data.Adi + ' ';
    if (data.Soyadi) title += data.Soyadi + ' ';
    return title.trim(); // Remove any trailing spaces
  }

}
